import React from "react";
import { render } from "react-dom";
import { Provider } from 'react-redux'

import store from '../usa_quickturn_pcb/store'
import App from "../usa_quickturn_pcb/App";
import Cart from "../usa_quickturn_pcb/cart/Cart";

document.addEventListener("DOMContentLoaded", () => {
  var appContainer = document.getElementById("quote-form");
  var cartContainer = document.getElementById("cart-form");
  if (appContainer != null) {
    render(
      <Provider store={store}>
        <App />
      </Provider>,
      appContainer
    );
  }

  if (cartContainer) {
    render(
      <Provider store={store}>
        <Cart />
      </Provider>,
      cartContainer
    );
  }
});
